import { Divider, Space } from 'antd'

import { ReloadAreaTreeButton } from './ReloadButton'
import { ToggleExpandAllAreaTreeButton } from './ToggleExpandButton'
import { AreaTreeValueTag } from './ValueTag'

export const AreaTreeToolbar = () => {
  return (
    <>
      <Space align='center'>
        <ReloadAreaTreeButton />
        <ToggleExpandAllAreaTreeButton />
      </Space>
      <AreaTreeValueTag />
      <Divider orientation='horizontal' />
    </>
  )
}
